/**
 * USERINFO
 */
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_CT_USER_INFO = 'SET_CT_USER_INFO';
export const USERINFO_STATUS = 'USERINFO_STATUS';
export const SET_USER_BEHAVIOR_TABLE = 'SET_USER_BEHAVIOR_TABLE';

/**
 * CURRENT
 */
export const SET_CURRENT_SEARCH_INFO = 'SET_CURRENT_SEARCH_INFO';
export const SET_CURRENT_REPORT_TIME = 'SET_CURRENT_REPORT_TIME';
export const SET_CURRENT_CT_REPORT_TIME = 'SET_CURRENT_CT_REPORT_TIME';
export const SET_MENU_COLLAPSED = 'SET_MENU_COLLAPSED';
export const SET_APPLICATION_INFO = 'SET_APPLICATION_INFO';
export const SET_AI_PRODUCT_DETAIL_INFO = 'SET_AI_PRODUCT_DETAIL_INFO';
export const SET_SOUND_STATE = 'SET_SOUND_STATE';
export const SET_NEWTASK_STATE = 'SET_NEWTASK_STATE';
export const SET_MENUTASKFLAG_STATE = 'SET_MENUTASKFLAG_STATE';
export const SET_MENU_OPEN_LIST = 'SET_MENU_OPEN_LIST';
export const CURRENT_STATUS = 'CURRENT_STATUS';
export const SET_PREV_PAGE = 'SET_PREV_PAGE';
export const NATIONAL_DICT = 'NATIONAL_DICT';
export const IDTYPE_DICT = 'IDTYPE_DICT';
export const CARDTYPE_DICT = 'CARDTYPE_DICT';

/**
 * AI SCREEN
 */
export const SET_AI_HEATMAP_DATA_SOURCE = 'SET_AI_HEATMAP_DATA_SOURCE';
export const SET_AI_PRODUCT_HEATMAP_DATA = 'SET_AI_PRODUCT_HEATMAP_DATA';
export const SET_AI_HEATMAP_DATA = 'SET_AI_HEATMAP_DATA';
export const SET_AI_SCORES_DATA = 'SET_AI_SCORES_DATA';
export const AI_SCREEN_STATUS = 'SET_AI_SCORES_DATA';
export const HEATMAP_STATE = 'HEATMAP_STATE';

export const SET_DATADICT_LOCATION_LABELS = 'SET_DATADICT_LOCATION_LABELS';
